import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import {
  UploadStatus,
  useVehicleGalleryContext,
} from '@/contexts/vehicle-gallery-provider';
import { RefreshCcw } from 'lucide-react';

/**
 * As already mentioned within the gallery code, currenlty we don't rely on delta packets when it comes to vehicle image changes.
 * This means we don't know if someone deleted an image, uploaded, marked as featured, moved, etc.
 * These changes are hard to track manually in code, so instead of trying to figure out what change happened without delta packets,
 * we give user ability to force a refresh if he suspects that new version needs to be loaded (eg. indicator could be that user is
 * trying to perform action on deleted image which gives back an error, this is when image reload can become handy).
 */
export const ForceReloadBtn = () => {
  const { forceReload, uploadStatus, showImageCategoryEditor } =
    useVehicleGalleryContext();

  if (uploadStatus != UploadStatus.NONE || showImageCategoryEditor) {
    return null;
  }

  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger asChild>
        <Button
          variant="warning"
          className="cursor-pointer"
          onClick={() => forceReload()}
        >
          <RefreshCcw />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Reload images</TooltipContent>
    </Tooltip>
  );
};
